const selectedFilters = (state = {}, action) => {
    let localState = state;
    switch (action.type) {
        case 'SELECTED_FILTERS_TOGGLE':

            if (action.data.reset === true) {
                return {};
            }

            if(typeof localState[action.data.filter_group_id] === 'undefined') {
                // create new array in object
                localState[action.data.filter_group_id] = [];
            }

            if (localState[action.data.filter_group_id].indexOf(action.data.value_id) === -1) {

                if (action.data.filter_type === 'select') {
                    localState[action.data.filter_group_id] = [];
                }

                // doesn't exist - add to array
                localState[action.data.filter_group_id].push(action.data.value_id);
            } else {
                // does exist - remove from array
                localState[action.data.filter_group_id].splice(localState[action.data.filter_group_id].indexOf(action.data.value_id), 1);
            }

            if (action.data.filter_type === 'select' && action.data.value_id === "") {
                delete localState[action.data.filter_group_id];
            }

            return {...localState};
        default:
            return localState;
    }
};

export default selectedFilters;
